import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { STATUS } from '../../utils/status';
import { VendorAnalyticsCompletedState } from '../interfaces/interface';
import { getCompletedVendorAnalytics, getVendorAnalytic } from '../slices/analytics/vendor';

const ExtraReducers = (builder: ActionReducerMapBuilder<VendorAnalyticsCompletedState>) => {
  builder
  .addCase(getCompletedVendorAnalytics.pending, (state) => {
    state.getVendorAnalyticsStatus = STATUS.PENDING;
    state.getVendorAnalyticsMessage = null
  })
  .addCase(getCompletedVendorAnalytics.fulfilled, (state, action) => {
    state.getVendorAnalyticsStatus = STATUS.SUCESS;
    state.VendorAnalyticsCompleted = action.payload;
    state.getVendorAnalyticsMessage = null
  })
  .addCase(getCompletedVendorAnalytics.rejected, (state, action: any) => {
    state.getVendorAnalyticsStatus = STATUS.FAILED;
    state.getVendorAnalyticsMessage = action.payload?.message || "An error occurred"
  })
  .addCase(getVendorAnalytic.pending, (state) => {
    state.getVendorStatus = STATUS.PENDING;
    state.getVendorMessage = null
  })
  .addCase(getVendorAnalytic.fulfilled, (state, action) => {
    state.getVendorStatus = STATUS.SUCESS;
    state.VendorAnalytics = action.payload;
    state.getVendorMessage = null
  })
  .addCase(getVendorAnalytic.rejected, (state, action: any) => {
    state.getVendorStatus = STATUS.FAILED;
    state.getVendorMessage = action.payload?.message || "An error occurred"
  });
};

export default ExtraReducers;
